<template>
  <div class="d-flex align-items-center flex-column pt-5">
    <div class="d-lex flex-row">
      <button class="button" @click="exportToPDF" id="button">
        <i class="el-icon-document mr-2" ></i>
        Download PDF
      </button>
      <button class="button ml-4 mb-5" @click="printDocument" id="button">
        <i class="el-icon-printer mr-2" ></i>
        Print
      </button>
    </div>
    <ReceiptForm id="receipt"/>
  </div>
</template>
<script>
import * as jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import ReceiptForm from '@/components/ReceiptForm'

export default {
  components: {
    ReceiptForm
  },
  async created() {
    // this.renderCanvas()
  },
  methods: {
    async renderCanvas() {
      const doc = new jsPDF()
      setTimeout(async() => {
        const canvas = await html2canvas(document.getElementById('receipt'))
        console.log('renderCanvas', canvas)
        document.getElementById('test-mobile').appendChild(canvas)
      }, 1000);
    },
    async exportToPDF() {
      const doc = new jsPDF()
      $('#receipt').addClass('no-border')
      const canvas = await html2canvas(document.getElementById('receipt'))
      // document.getElementById('test-mobile').appendChild(canvas)
      const imgData = canvas.toDataURL('image/png')
      doc.addImage(imgData, 'PNG', -1, -4)
      doc.save('ReceiptMLRS2019.pdf')
      $('#receipt').removeClass('no-border')
    },
    async printDocument() {
      window.print()
    }
  }
}
</script>
<style lang="scss" scoped>
#receipt {
  border: 1px solid black;
}
.no-border {
  border: none !important;
}
.button {
  border: 3px solid #C9D6FF;
  border-radius: 10px;
  padding: 5px;
  width: 175px;
  height: 50px;
  font-size: 1rem;
  font-weight: 500;
}
.button:hover {
  color: white;
  background: #C9D6FF;
}
@media print {
  #receipt {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    border: none;
  }
  .button {
    visibility: hidden;
  }
}
</style>
